export const adapters = [
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "105TC",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "106CN",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "107 LHN",
        "Brand": "Pettinaroli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107L",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LD - 107LKIT",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "107LHC",
        "Brand": "Pettinaroli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "107LHN",
        "Brand": "Pettinaroli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LKIH - 107LKIS",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LOD",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "107LR",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "108L",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "109L",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "109L Chrome",
        "Brand": "Pettinaroli",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "130",
        "Brand": "Pintossi",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "13030000",
        "Brand": "Pintossi",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "danfoss_ravl",
        "name": "1610",
        "Brand": "FAR",
        "field6": "",
        "productId": "6647643865155"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "1820",
        "Brand": "FAR",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "1824",
        "Brand": "FAR",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "1825",
        "Brand": "FAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "1828",
        "Brand": "FAR",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "2080",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "320 KD",
        "Brand": "GAMPPERARMATUREN",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "320 KH...",
        "Brand": "GAMPPERARMATUREN",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "348811HB",
        "Brand": "Alliance",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "7230-7260",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "7235",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "7262",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "8250",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "8251",
        "Brand": "Herz",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "9200-9201",
        "Brand": "Herz",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9230-9260",
        "Brand": "Herz",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9553",
        "Brand": "Tiemme",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9556",
        "Brand": "Tiemme",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9559",
        "Brand": "Tiemme",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "9860 - 9860H - 9861 - 9861H",
        "Brand": "Herz",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Aduna",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Arima-Eroso",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "B",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "BTRV15LS",
        "Brand": "Boss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Brillant Plus Series",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Brillant Series",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Bull Dog",
        "Brand": "Pegler",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "C - Diamant Plus Series",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "C - Diamant Series",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "200",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "201",
        "Brand": "Caleffi",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "202",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "203",
        "Brand": "Caleffi",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "204",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "WICAL 210",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "compatible",
        "adapter": "Caleffi",
        "name": "205",
        "Brand": "Caleffi",
        "field6": "",
        "productId": "6645012070467"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Connect - Connect Z",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "D",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "D-U",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DH 01",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DR - Diamant Plus Series",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DR - Diamant Series",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DTW",
        "Brand": "MMA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX Beige",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX Black",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX Grey",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "DX White",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Deco Chrome",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Deco Comap Silver",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "ECA",
        "Brand": "ValfSanayii",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Ecocal",
        "Brand": "Altecnic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Evosense Public",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Evosense Sprint",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Evosense Standard",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "F",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Fusion",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "HT Diamant Plus Series",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "HT Diamant Series",
        "Brand": "Schlosser",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Harmony",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Iris",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "K",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "K old",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "K470H",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "",
        "name": "Living eco 1",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "",
        "name": "Living eco 2",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "M28",
        "Brand": "ARCO",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "M28 V1",
        "Brand": "ARCO",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "M30 V1",
        "Brand": "ARCO",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "MTN51GB TRV",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "MTW AD",
        "Brand": "MMA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Mini Series",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "",
        "name": "Model 1",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Model 2",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Petite",
        "Brand": "Myson",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra/ M30x15",
        "name": "Pinox D",
        "Brand": "Oventrop",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Pinox H",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Giacomini",
        "name": "R460",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "R460H",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "R462",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "R463",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Giacomini",
        "name": "R468",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "R468H",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "Giacomini",
        "name": "R470",
        "Brand": "Giacomini",
        "field6": "",
        "productId": "6645013676099"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "R470H",
        "Brand": "Giacomini",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RA 2000",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RA 2920",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RA33S",
        "Brand": "BathEmpire",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAE-K",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAL 9005",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAL 9016",
        "Brand": "JAGA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAS-C2",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAS-CK",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAS-D2",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAW",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX Stainless steel",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX Black",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX Chrome",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RAX White",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAX-K Chrome",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RAX-K White",
        "Brand": "Danfoss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 212",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 411 D",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 411 H",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT 414",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT112",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT212",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT313",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT414",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RT56.05",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RTN",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "RTN51",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "RTW",
        "Brand": "Danfoss",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Radio",
        "Brand": "Blyss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Rondostat HR20",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "SH - Diamant Invest",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "SH - Diamant Plus Series",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "SH - Diamant Series",
        "Brand": "Schlosser",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Sensitive Blanc",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Sensitive Chrome",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Sensity",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "Senso",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Senso all color",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "Senso old",
        "Brand": "SARCOMAP",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Simple",
        "Brand": "Blyss",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T 1000",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T 3000",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T 5000",
        "Brand": "IVAR",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T100M",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "T100V-T100VM",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "danfoss_ra",
        "name": "TD 3000",
        "Brand": "IVAR",
        "field6": "",
        "productId": "6646021881923"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "TRV 2 Way",
        "Brand": "Myson",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15/M28x15",
        "name": "TRV 300",
        "Brand": "Heimeier",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV 4 Chrome",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV 4 Classic",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV1",
        "Brand": "ECA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV1",
        "Brand": "ValfSanayii",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV2",
        "Brand": "ECA",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV2",
        "Brand": "ValfSanayii",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV200",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x15",
        "name": "TRV300",
        "Brand": "TA",
        "field6": "",
        "productId": "6645014298691"
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV300",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV4 Chrome",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV4 Classic",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TRV4 White",
        "Brand": "Drayton",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV500",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "TRV510",
        "Brand": "Sunvic",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TS",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TS - 5.11",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "TS DCC",
        "Brand": "Eberle",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Tala",
        "Brand": "Orkli",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-100",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-2",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-20",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-200",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-3",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-4 Classic",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-4 Design",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thera-EL",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thermo",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Thermostatic Head W5",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Trade",
        "Brand": "Siemens",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni L",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LA",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni LD",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible_with_adapter_danfoss",
        "adapter": "M33x20",
        "name": "Uni LDV",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LDVL",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni LH",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni LHB",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LI",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LK",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LM",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LO",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "incompatible",
        "adapter": "",
        "name": "Uni LR",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "Uni LV",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni SH",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni XH",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Uni XHM",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Heimeier VK",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Heimeier VK old",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "VT117e - VTL120",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "VT15",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "VT200e",
        "Brand": "HoneywellBraukmann",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vector",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vindo CH",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vindo TH",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vinto RTD",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Vinto TD",
        "Brand": "Oventrop",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "Virgo",
        "Brand": "Valvex",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M28x10",
        "name": "WESTHERM 5",
        "Brand": "SARCOMAP",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "WK",
        "Brand": "Heimeier",
        "field6": ""
    },
    {
        "compatibility": "compatible",
        "adapter": "M30x15",
        "name": "WK old",
        "Brand": "Heimeier",
        "field6": ""
    }
];

export const brands = [
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97c075b400156bbb2a",
        "name": "ARCO",
        "linkname": "arco",
        "imgname": "Arco"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e98342e2d001461fe16",
        "name": "Alliance",
        "linkname": "alliance",
        "imgname": "Alliance"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97413a7b001386755e",
        "name": "Altecnic",
        "linkname": "altecnic",
        "imgname": "Altecnic"
    },
    {
        "compatibility": "compatible",
        "adapter": null,
        "_id": "5f105e9ec075b400156bbb35",
        "name": "BRV",
        "linkname": "brv",
        "imgname": "BRV"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97413a7b001386755d",
        "name": "BathEmpire",
        "linkname": "bath-empire",
        "imgname": "BathEmpire"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e97342e2d001461fe15",
        "name": "Blyss",
        "linkname": "blyss",
        "imgname": "Blyss"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96342e2d001461fe14",
        "name": "Boss",
        "linkname": "Boss",
        "imgname": "Boss"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9e413a7b0013867566",
        "name": "Caleffi",
        "linkname": "caleffi",
        "imgname": "Caleffi"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e98413a7b001386755f",
        "name": "Danfoss",
        "linkname": "danfoss",
        "imgname": "Danfoss"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96342e2d001461fe13",
        "name": "Drayton",
        "linkname": "drayton",
        "imgname": "Drayton"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96413a7b001386755c",
        "name": "ECA",
        "linkname": "eca",
        "imgname": "ECA"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e95413a7b001386755a",
        "name": "EMMETI",
        "linkname": "emmeti",
        "imgname": "EMMETI"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e95413a7b0013867559",
        "name": "EQ-3",
        "linkname": "eq-3",
        "imgname": "EQ-3"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e94413a7b0013867558",
        "name": "EUROTRONIC",
        "linkname": "eurotronic",
        "imgname": "EUROTRONIC"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e96c075b400156bbb29",
        "name": "Eberle",
        "linkname": "eberle",
        "imgname": "Eberle"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e95413a7b001386755b",
        "name": "Elgato",
        "linkname": "elgato",
        "imgname": "Elgato"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e93342e2d001461fe11",
        "name": "FAR",
        "linkname": "far",
        "imgname": "FAR"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e92413a7b0013867557",
        "name": "GAMPPERARMATUREN",
        "linkname": "GAMPPERARMATUREN",
        "imgname": "GAMPPERARMATUREN"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e94342e2d001461fe12",
        "name": "GENEBRE",
        "linkname": "genebre",
        "imgname": "GENEBRE"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9e342e2d001461fe1b",
        "name": "Giacomini",
        "linkname": "giacomini",
        "imgname": "Giacomini"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9d342e2d001461fe1a",
        "name": "Heimeier",
        "linkname": "heimeier",
        "imgname": "Heimeier"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9dc075b400156bbb33",
        "name": "Herz",
        "linkname": "herz",
        "imgname": "Herz"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9d413a7b0013867565",
        "name": "HoneywellBraukmann",
        "linkname": "honeywell-braukmann",
        "imgname": "Honeywell"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e92c075b400156bbb23",
        "name": "IVAR",
        "linkname": "ivar",
        "imgname": "IVAR"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9dc075b400156bbb32",
        "name": "JAGA",
        "linkname": "jaga",
        "imgname": "Jaga"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9c342e2d001461fe19",
        "name": "Landis&gyr",
        "linkname": "landis--gyr",
        "imgname": "Landis&gyr"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e92c075b400156bbb22",
        "name": "MMA",
        "linkname": "mma",
        "imgname": "MMA"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9c413a7b0013867564",
        "name": "MNG",
        "linkname": "mng",
        "imgname": "MNG"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e93c075b400156bbb25",
        "name": "Myson",
        "linkname": "myson",
        "imgname": "Myson"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9c413a7b0013867563",
        "name": "Orkli",
        "linkname": "orkli",
        "imgname": "Orkli"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9cc075b400156bbb31",
        "name": "Oventrop",
        "linkname": "oventrop",
        "imgname": "Oventrop"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e91413a7b0013867556",
        "name": "Pegler",
        "linkname": "pegler",
        "imgname": "Pegler"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9ec075b400156bbb34",
        "name": "Pettinaroli",
        "linkname": "pettinaroli",
        "imgname": "Pettinaroli"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e91342e2d001461fe10",
        "name": "Pintossi",
        "linkname": "pintossi",
        "imgname": "Pintossi"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9b413a7b0013867562",
        "name": "Polytronic",
        "linkname": "polytronic",
        "imgname": "Polytronic"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9bc075b400156bbb30",
        "name": "Pont-à-Mousson",
        "linkname": "pont--mousson",
        "imgname": "Pont-à-Mousson"
    },
    {
        "compatibility": "compatible",
        "adapter": null,
        "_id": "5f105e9bc075b400156bbb2f",
        "name": "RBMrobsom",
        "linkname": "rbm--robsom",
        "imgname": "RBMrobsom"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9ac075b400156bbb2e",
        "name": "Rossweiner",
        "linkname": "rossweiner",
        "imgname": "Rossweiner"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9ac075b400156bbb2d",
        "name": "SARCOMAP",
        "linkname": "sar-comap",
        "imgname": "SarComap"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e9a413a7b0013867561",
        "name": "Sam-Slovarm",
        "linkname": "sam---slovarm",
        "imgname": "Sam-Slovarm"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e9ac075b400156bbb2c",
        "name": "Schlosser",
        "linkname": "schlsser",
        "imgname": "Schlosser"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e94c075b400156bbb26",
        "name": "Siemens",
        "linkname": "siemens",
        "imgname": "Siemens"
    },
    {
        "compatibility": "compatible_with_adapter_m28x1",
        "adapter": null,
        "_id": "5f105e94c075b400156bbb27",
        "name": "Sunvic",
        "linkname": "sunvic",
        "imgname": "Sunvic"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e91c075b400156bbb21",
        "name": "TA",
        "linkname": "ta",
        "imgname": "TA"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e93c075b400156bbb24",
        "name": "TADO",
        "linkname": "tado",
        "imgname": "Tado"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e99342e2d001461fe18",
        "name": "Tiemme",
        "linkname": "tiemme",
        "imgname": "Tiemme"
    },
    {
        "compatibility": "compatible_with_adapter_vaillant",
        "adapter": null,
        "_id": "5f105e95c075b400156bbb28",
        "name": "Vaillant",
        "linkname": "vaillant",
        "imgname": "Vaillant"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e99413a7b0013867560",
        "name": "ValfSanayii",
        "linkname": "valf-sanayii",
        "imgname": "ValfSanayii"
    },
    {
        "compatibility": "valvesmodel",
        "adapter": null,
        "_id": "5f105e99c075b400156bbb2b",
        "name": "Valvex",
        "linkname": "valvex",
        "imgname": "Valvex"
    },
    {
        "compatibility": "compatible",
        "adapter": "m30x15",
        "_id": "5f105e98342e2d001461fe17",
        "name": "Watts",
        "linkname": "watts",
        "imgname": "Watts"
    }
];